export function dataTagsNews (state) {
    return state.dataTagsNews
}